module.exports = __webpack_public_path__ + "static/nfc_payments-e17b30ff49b6b96863f34e3c2c78cae3.png";